import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Advantages from '../../components/front/Advantages';
import Banner from '../../components/front/Banner';
import CalculatorTeaser from '../../components/front/CalculatorTeaser';
import Footer from '../../components/front/Footer';
import Header from '../../components/front/Header';
import PlatformDetails from '../../components/front/PlatformDetails';
import Pricing from '../../components/front/Pricing';
import RegistrationForm from '../../components/front/RegistrationForm';
import Testimonials from '../../components/front/Testemonials';
import WhyUs from '../../components/front/WhyUs';
import './style.css';

const HomePage = () => {
    const location = useLocation();

    useEffect(() => {
        const id = String(location.hash || '').replace('#', '');
        if (!id) {
            return undefined;
        }
        const timer = window.setTimeout(() => {
            const el = document.getElementById(id);
            const headerHeight = document.querySelector('header')?.offsetHeight || 72;
            if (el) {
                window.scrollTo({ top: el.offsetTop - headerHeight, behavior: 'smooth' });
            }
        }, 150);
        return () => window.clearTimeout(timer);
    }, [location.hash]);

    return (
    <Box className="public-site" sx={{ bgcolor: '#fff', minHeight: '100vh' }}>
        <Header />
        <Banner />
        <PlatformDetails />
        <Advantages />
        <CalculatorTeaser />
        {/* <Testimonials /> */}
        <Pricing />
        <WhyUs />
        <RegistrationForm />
        <Footer />
    </Box>
    );
};

export default HomePage;
